<div style="position: relative">
  <div *ngIf="!hasData" class="rounded-div"></div>
  <highcharts-chart [ngClass]="{ 'empty-chart': !hasData }" [Highcharts]="Highcharts" [options]="chartOptions" style="width: 280px; height: 150px; display: block"></highcharts-chart>
</div>
